import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { mergeData } from "../../../actions/collector/auth";
import Textarea from "../../inputs/Textarea";
import TextInput from "../../inputs/TextInput";
import { Button } from "../../util/Clickable";
import { getPureMessage, IntlText } from "../../util/Text";
import * as validate from "../../util/Validator";

class InquiryForm extends PureComponent {
  state = {
    loading: false,
    recaptchaReady: false,
  };

  componentDidMount() {
    this.checkRecaptchaInterval = setInterval(() => {
      if (this.props.googleReCaptchaProps?.executeRecaptcha) {
        this.setState({ recaptchaReady: true });
        clearInterval(this.checkRecaptchaInterval);
      }
    }, 100);

    this.recaptchaTimeout = setTimeout(() => {
      clearInterval(this.checkRecaptchaInterval);
      if (!this.state.recaptchaReady) {
        console.error("reCAPTCHA loading timeout");
      }
    }, 10000);
  }

  componentWillUnmount() {
    if (this.checkRecaptchaInterval) {
      clearInterval(this.checkRecaptchaInterval);
    }
    if (this.recaptchaTimeout) {
      clearTimeout(this.recaptchaTimeout);
    }
  }

  onSubmit = async (values) => {
    this.setState({
      loading: true,
    });
    this.props.actions.mergeData(values);

    try {
      // reCAPTCHA トークンを取得（最大5秒待機）
      const maxWaitTime = 5000; // 5秒
      const startTime = Date.now();

      while (!this.props.googleReCaptchaProps?.executeRecaptcha) {
        if (Date.now() - startTime > maxWaitTime) {
          this.setState({ loading: false });
          throw new Error(
            getPureMessage("forms.error.recaptcha_not_ready") ||
              "セキュリティチェックの読み込みに失敗しました。ページを再読み込みしてもう一度お試しください。",
          );
        }
        // 100ms待機してから再チェック
        await new Promise((resolve) => setTimeout(resolve, 100));
      }

      const token = await this.props.googleReCaptchaProps.executeRecaptcha(
        "inquiry_form",
      );
      const valuesWithToken = { ...values, recaptcha_token: token };

      return this.props.onSubmit(valuesWithToken).then(({ value, action }) => {
        if (value.status < 300) {
          this.setState(
            {
              loading: false,
            },
            () => {
              this.props.onSuccess &&
                this.props.onSuccess(value.data, value.response);
            },
          );
        } else {
          this.setState({
            loading: false,
          });
          const errors = Object.keys(value.errors).reduce((dic, key) => {
            dic[key] = Array.isArray(value.errors[key])
              ? value.errors[key].join("\n")
              : null;
            return dic;
          }, {});
          throw new SubmissionError(errors);
        }
      });
    } catch (error) {
      this.setState({
        loading: false,
      });
      throw error;
    }
  };

  render = () => {
    return (
      <form
        onSubmit={this.props.handleSubmit(this.onSubmit)}
        action={this.props.action}
        method="post"
      >
        <div className="uk-margin-ssmall">
          <Field
            className="uk-form-clear"
            name="tel"
            type="tel"
            component={TextInput}
            labelId="forms.attr.tel"
            validate={[validate.required, validate.tel]}
            required
            placeholder={getPureMessage("forms.placeholder.tel")}
          />
          <div className="uk-margin-ssmall">
            <Field
              name="country"
              type="text"
              component={TextInput}
              validate={[validate.required]}
              required
              labelId="forms.attr.purchase.country"
              placeholder={getPureMessage("forms.placeholder.country")}
            />
          </div>
          <div className="uk-margin-ssmall">
            <Field
              name="address"
              component={Textarea}
              className="uk-form-textarea-xsmall"
              validate={[validate.required]}
              required
              labelId="forms.attr.purchase.address"
              placeholder={getPureMessage("forms.placeholder.address")}
            />
          </div>
          <div className="uk-margin-ssmall">
            <Field
              className="uk-form-textarea-small"
              name="collector_message"
              component={Textarea}
              labelId="forms.attr.question"
              placeholder=" "
              validate={[validate.required]}
              required
            />
          </div>
        </div>
        {(() => {
          if (this.props.error) {
            return (
              <div className="uk-margin-ssmall uk-text-danger uk-text-center@s">
                <span>{this.props.error}</span>
              </div>
            );
          }
        })()}
        <div className="uk-margin-ssmall uk-text-center">
          <Button
            className="uk-button uk-button-accent uk-button-large"
            type="submit"
            disabled={
              this.props.invalid ||
              !this.props.googleReCaptchaProps?.executeRecaptcha
            }
            ga={{ category: this.props.form, action: "submit" }}
            loading={this.state.loading ? 1 : 0}
          >
            <IntlText id="forms.attr.inquiry.submit" />
          </Button>
          {!this.state.recaptchaReady && (
            <div className="uk-margin-small uk-text-muted uk-text-small">
              <span>セキュリティチェックを読み込み中...</span>
            </div>
          )}
        </div>
        <Field name="gallery_id" type="hidden" component={TextInput} noError />
      </form>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    collector:
      state.auth.data && state.auth.role == "collector" ? state.auth.data : {},
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      mergeData: (param) => dispatch(mergeData(param)),
    },
    dispatch,
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: "collector-inquiry-form",
    withRef: true,
    // enableReinitialize : true
  })(withGoogleReCaptcha(InquiryForm)),
);
